import React from 'react'
import { Stack, Text, Flex } from '@chakra-ui/react'

import { IDashboardCollaborator } from 'services/IApi.d'


interface IRepresentativeProps {
  person: IDashboardCollaborator[]
}

// Representantes Legal
const PersonRepresentative = ({ person }: IRepresentativeProps) => (
  <>
    {person.map(({ name, lastName, documentNumber, documentType, nationality }, indexPerson) => (
      <Stack
        data-testid={`personCollab-${indexPerson}`}
        key={`personCollab-${documentNumber}`}
        display='flex'
        direction='row'
        p='10px 0'
        alignItems='center'
        borderBottom='solid 1px #ddd'
        _last={{ borderBottomWidth: 0 }}
        flexBasis='auto'
      >
        <Flex flex={1} data-testid={`personCollab-${documentNumber}`} key={`collaborator-${documentNumber}`}>
          <Flex flex={1} justifyContent='start'>
            <Text data-testid={`personCollab-${documentNumber}-name`} textStyle='titleSm' fontWeight='400' size='2xs' line-height='md' color='secondary.500'>{name} {lastName}</Text>
          </Flex>
          <Flex flex={1} justifyContent='end'>
            <Text data-testid={`personCollab-${documentNumber}-cuit`} textAlign={'right'} textStyle='bodyMd' fontWeight='400' size='2xs' line-height='md' color='secondary.900'>{nationality === 'AR' ? 'CUIL' : documentType} {documentNumber}</Text>
          </Flex>
        </Flex>
      </Stack>
    ))}
  </>
)

export default PersonRepresentative